import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}

:host {
  display: block;
}

.inline-list {
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

hr {
  border: 0;
  color: inherit;
  height: 1px;
  background: var(--p-border);
  margin: 1em 0;
}

.label {
  display: block;
  word-break: break-word;
  font-size: var(--p-label-font-size, .9rem);
  line-height: var(--p-label-line-height, 1.3);
  font-weight: var(--p-label-font-weight, bold);
  margin-bottom: var(--p-label-margin-bottom, .5em);
  color: var(--p-text-color);
}

.copy-wrap {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  margin-bottom: var(--p-input-margin-bottom);
}

.copy-wrap p-input {
  width: 100%;
  --p-input-margin-bottom: 0;
}

.embed-type {
  border: 0;
  padding: 0;
  margin: 0 0 1em;
}

.embed-type-options {
  display: flex;
  gap: 1rem;
}

.embed-type-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: var(--p-label-font-size, .9rem);
  color: var(--p-text-color);
}

.embed-type-option input[type="radio"] {
  accent-color: var(--p-primary);
  margin: 0;
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.code-preview {
  position: relative;
  margin-bottom: var(--p-input-margin-bottom);
}

.code-preview pre {
  background-color: #1e1e1e;
  color: #d4d4d4;
  border: 1px solid #3c3c3c;
  border-radius: 4px;
  margin: 0;
  padding: 1em;
  padding-right: 3em;
  overflow-x: auto;
  font-family: ui-monospace, SFMono-Regular, Consolas, Menlo, monospace;
  font-size: 0.875em;
  line-height: 1.5;
  color-scheme: dark;
  white-space: pre-wrap;
  word-break: break-all;
}

.code-preview code {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  font-family: inherit;
}

.copy-code-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
`;
